/* eslint-disable */
import React from 'react';
import { Box } from '@material-ui/core';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const HistoricPerformanceRevenue = ({
  rollingData,
  monthlyRevenueData,
  yearlyRevenueData,
  userSelectionRevenue1,
  currentYearDataRevenue,
  yearlyRevenueTarget,
}) => {
  const monthNames = {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec',
  };

  const getDefaultXAxisCategories = (data) => Object.keys(data).map((month) => monthNames[month]);

  const defaultXAxisCategories = getDefaultXAxisCategories(rollingData);
  const monthlyXAxisCategories = getDefaultXAxisCategories(monthlyRevenueData);
  const currentYearXAxisCategories = getDefaultXAxisCategories(currentYearDataRevenue);

  // Extract the targets for Revenue and Gross Profit
  const revenueTarget =
    yearlyRevenueTarget.find(
      (target) =>
        target.questionDetails.sectionDetails.typeShortName ===
          'VectorTargets' + new Date().getFullYear() &&
        target.questionDetails.text.includes('Revenue'),
    )?.answer || 0;

  const grossProfitTarget =
    yearlyRevenueTarget.find(
      (target) =>
        target.questionDetails.sectionDetails.typeShortName ===
          'VectorTargets' + new Date().getFullYear() &&
        target.questionDetails.text.includes('Gross Profit'),
    )?.answer || 0;

  const getTargetSeries = (length, target) => ({
    name: 'Top Performer',
    data: new Array(length).fill(Number(target)),
    type: 'line',
    color: '#FF3E32',
    dashStyle: '',
    marker: {
      enabled: false,
      symbol: 'circle',
      radius: 6,
      fillColor: '#FF3E32',
    },
    lineWidth: 6,
    legendIndex: 1,
    states: {
      hover: {
        lineWidthPlus: 0,
      },
    },
    showInLegend: true,
  });

  const baseChartOptions = {
    chart: {
      type: 'column',
    },
    title: {
      text: '',
    },
    yAxis: {
      title: {
        text: 'USD',
      },
    },
    legend: {
      useHTML: true,
      symbolHeight: 12,
      symbolWidth: 12,
      symbolRadius: 6,
      // labelFormatter: function () {
      //   if (this.name === 'Target') {
      //     return `<span style="display: inline-block; width: 10px; height: 10px; background-color: red; border-radius: 50%;"></span> ${this.name}`;
      //   }
      //   return this.name;
      // },
    },
    plotOptions: {
      column: {
        color: '#003C6F',
      },
    },
  };

  const generateSeries = (data, key = 'operationalRevenue') => ({
    name: 'My Performance',
    data: Object.values(data).map((item) => item[key]),
    color: '#003C6F',
  });

  const defaultChartData = {
    ...baseChartOptions,
    xAxis: {
      categories: defaultXAxisCategories,
    },
    series: [
      generateSeries(rollingData),
      getTargetSeries(defaultXAxisCategories.length, revenueTarget),
    ],
  };

  const sameYearChartData = {
    ...baseChartOptions,
    xAxis: {
      categories: currentYearXAxisCategories,
    },
    series: [
      generateSeries(currentYearDataRevenue),
      getTargetSeries(currentYearXAxisCategories.length, revenueTarget),
    ],
  };

  const monthlyChartData = {
    ...baseChartOptions,
    xAxis: {
      categories: monthlyXAxisCategories,
    },
    series: [
      generateSeries(monthlyRevenueData),
      getTargetSeries(monthlyXAxisCategories.length, revenueTarget),
    ],
  };

  const yearlyChartData = {
    ...baseChartOptions,
    xAxis: {
      categories: Object.keys(yearlyRevenueData),
    },
    series: [],
  };

  if (userSelectionRevenue1 === 'yearly') {
    const selectedYears = Object.keys(yearlyRevenueData);

    selectedYears.forEach((year, index) => {
      const yearData = yearlyRevenueData[year];
      const countryName = 'Revenue';
      yearData.forEach((countryData) => {
        const operationalRevenue = countryData.operationalRevenue;
        let countrySeriesItem = yearlyChartData.series.find(
          (seriesItem) => seriesItem.name === countryName,
        );
        if (!countrySeriesItem) {
          countrySeriesItem = {
            name: countryName,
            data: new Array(selectedYears.length).fill(null), // Initialize data array
            color: '#003C6F',
          };
          yearlyChartData.series.push(countrySeriesItem);
        }
        // Set operational revenue data at the appropriate index corresponding to the year
        countrySeriesItem.data[index] = operationalRevenue;
      });
    });

    const targetYearIndex = selectedYears.indexOf("'" + new Date().getFullYear() + "'");
    if (targetYearIndex !== -1) {
      const targetSeriesData = new Array(selectedYears.length).fill(null);
      targetSeriesData[targetYearIndex] = Number(revenueTarget);
      yearlyChartData.series.push({
        name: 'Top Performer',
        data: targetSeriesData,
        type: 'line',
        color: '#FF3E32',
        dashStyle: '',
        marker: {
          enabled: false,
          symbol: 'line',
          radius: 6,
          fillColor: '#FF3E32',
        },
        lineWidth: 6,
        legendIndex: 1,
        states: {
          hover: {
            lineWidthPlus: 0,
          },
        },
        showInLegend: true,
      });
    }
  }

  let chartOptions;
  switch (userSelectionRevenue1) {
    case 'monthly':
      chartOptions = monthlyChartData;
      break;
    case 'yearly':
      chartOptions = yearlyChartData;
      break;
    case 'currentYear':
      chartOptions = sameYearChartData;
      break;
    default:
      chartOptions = defaultChartData;
      break;
  }

  return (
    <Box mt={1}>
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </Box>
  );
};

export default HistoricPerformanceRevenue;
